import React from "react";

export const Divider = ({ className }: { className: string }): JSX.Element => {
  return <hr data-testid="divider" {...(className && { className })} />;
};
